(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cub-model-range"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cub-model-range')) {
  customElements.define('cub-model-range', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.category = 'all';
      this.year = this.querySelector('[data-year-filter]');
      this.cards = Array.from(this.querySelectorAll('[data-model-card]'));
      this.buttons = Array.from(this.querySelectorAll('[data-category]'));
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.category;
        this.update();
      }, options));
      this.year.addEventListener('change', () => this.update(), options);
      this.addEventListener('shopify:block:select', event => {
        this.category = 'all';
        this.year.value = 'all';
        this.update();
        event.target.scrollIntoView({ block: 'center' });
      }, options);
      this.querySelector('[data-controls]').hidden = false;
      this.update();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    countText(count) {
      return this.dataset.countTemplate.replace('[count]', String(count));
    }
    update() {
      let total = 0;
      this.cards.forEach(card => {
        card.hidden = !((this.category === 'all' || card.dataset.modelCategory === this.category) && (this.year.value === 'all' || card.dataset.modelYear === this.year.value));
        if (!card.hidden) total++;
      });
      this.buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.category === this.category));
        button.querySelector('[data-category-count]').textContent = this.cards.filter(card =>
          (button.dataset.category === 'all' || card.dataset.modelCategory === button.dataset.category) &&
          (this.year.value === 'all' || card.dataset.modelYear === this.year.value)
        ).length;
      });
      this.querySelectorAll('[data-year-group]').forEach(group => {
        const count = Array.from(group.querySelectorAll('[data-model-card]')).filter(card => !card.hidden).length;
        group.hidden = count === 0;
        group.querySelector('[data-group-count]').textContent = this.countText(count);
      });
      this.querySelector('[data-result-count]').textContent = this.countText(total);
      this.querySelector('[data-empty]').hidden = total !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
